module.exports = __webpack_public_path__ + "img/icon_5_18.32f74416.png";